export const EVENT_CONSTANTS = {
    FINANCE_CARD_CLICKED: "Finance_card_clicked",
    TRADE_IN_BANNER_VIEWED: "trade in banner viewed",
    TRADE_IN_BANNER: "viewed"
};

export const EVENT_DATA = {
    FINANCE_CARD_CLICKED: {
        eventCategory: "CDP Desktop variant B",
        eventAction: "Finance_card_clicked",
        eventLabel: "{{Finance_CDP}}",
        event: "custom_event"
    },
    TRADE_IN_BANNER: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "viewed",
        eventLabel: "trade_in_banner"
    }
};
